export const SERVER_API_URL = 'https://mausritter-colony.dco.ninja/server/'

export default {
  SERVER_API_URL
}
